import {
  StyleSheet,
  ImageBackground,
  SafeAreaView,
  useWindowDimensions,
} from "react-native";
import React from "react";
import { Heading, ScrollView, Text, View, Pressable } from "native-base";
import { StackScreenProps } from "../../types";
import { LinearGradient } from "expo-linear-gradient";
import Header from "../../components/Header";

const GovernmentPartnerships = ({
  navigation,
}: StackScreenProps<"GovernmentPartnerships">) => {
  const { width, height } = useWindowDimensions();

  return (
    <ImageBackground
      source={require("../../assets/president.png")}
      resizeMode="cover"
      style={{ width, height }}
    >
      <LinearGradient
        colors={[
          "rgba(11, 46, 89, 1)",
          "rgba(0, 0, 0, 0)",
          "rgba(41, 124, 224, 1)",
        ]}
        style={styles.overlay}
      >
        <SafeAreaView style={{ height }}>
          <ScrollView px={5}>
            <Header
              onPress={() => navigation.navigate("PublicPartnerships")}
              headingText="Presidential Fertilizer Initiative (PFI)"
              parentText="Public Partnerships"
            />
            <View justifyContent="center" mt={5} mb={5}>
              <Text textAlign="center" mb={5}>
                OCP Africa leverages on public and private partnerships, to
                develop and amplify the reach of its projects. We align our
                projects with that of federal and state governments for cohesion
                and efficacy.
              </Text>
              <Text textAlign="center" mb={5}>
                PFI-II, initiated by OCP Africa Nigeria in 2021, is a situation
                where blenders acquire and own raw materials for processing into
                fertilizers, as against PFI I, where government takes ownership
                of raw material and finished good before it gets to the farmers.
                PFI II, allows the blending companies take ownership of finished
                products, hence help in extensive market expansion through
                competitive pricing and product development activities. PFI II
                has really helped to deepen the market with an estimated annual
                NPK fertilizer production at 1.8million metric tons in 2021, as
                against the era of the initial PFI I (2017-2000) which have an
                annual NPK production that is less than 500,000 mt of
                fertilizers.
              </Text>

              <Text textAlign="center">
                PFI I helped in increasing blending capacities, as the number of
                blending capacities has increased from 8 blending units to over
                50 blending units, while PFI II, has help to increase the
                fertilizer offtake for the increased production capacity
                witnessed in the PFI I.
              </Text>
            </View>
          </ScrollView>
        </SafeAreaView>
      </LinearGradient>
    </ImageBackground>
  );
};

export default GovernmentPartnerships;

const styles = StyleSheet.create({
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(41, 100, 204, 0.3)",
  },
  overlay2: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
  },
});
